// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"3223afb4","454":"f0dbcf65","526":"6cad92fb","883":"ab64fb9c","966":"6cad92fb","968":"6cad92fb"}[chunkId] + ".chunk.css";
};